import React from 'react';
import Styles from './RenaultSandero.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';
import Hero from '../HeroForm/Hero';

const RenaultSandero = () => {
  return (
    
     <div className={Styles.main_page}>
     <h2>Renault Sandero</h2>
     {/*Carousel*/}
     <div className={Styles.car_image}>
       <Carousel images={cars} />
     </div>
    <Hero selectedCar="Renault Sandero" /> 
   </div>
  );
}

export default RenaultSandero;
